import { type FC } from "react";
import { type LinkBaseProps } from "@mui/material/Link/Link";
import * as Styled from "./TriggersWithArrows.styled";
import { Icons } from "@repo/ui";

type ArrowTriggerProps = LinkBaseProps & {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  disabled?: boolean;
  sx?: any;
};

export const TriggerArrowDown: FC<ArrowTriggerProps> = ({
  children,
  disabled,
  onClick,
  sx,
  ...rest
}) => (
  <Styled.Root
    underline="none"
    disabled={disabled}
    onClick={onClick}
    sx={sx}
    {...rest}
  >
    <Styled.TriggerText>{children}</Styled.TriggerText>
    <Styled.IconWrapper>
      <Icons.ArrowIconDown/>
    </Styled.IconWrapper>
  </Styled.Root>
);

export const TriggerArrowRight: FC<ArrowTriggerProps> = ({
  children,
  disabled,
  onClick,
  sx,
  ...rest
}) => (
  <Styled.Root
    underline="none"
    disabled={disabled}
    onClick={onClick}
    sx={sx}
    {...rest}
  >
    <Styled.TriggerText>{children}</Styled.TriggerText>
    <Styled.IconWrapper>
      <Icons.Arrow/>
    </Styled.IconWrapper>
  </Styled.Root>
);